/**
 * @param path 接口路径
 * @param method 接口类型默认get，get、post、put
 * @param isFormData 默认false, 表单格式true，false为json格式
 */
const requireApi = require.context(
    // api 目录的相对路径
    '.',
    // 是否查询子目录
    false,
    // 查询文件的一个后缀
    /\.js$/
  );

const apiObj = {};
requireApi.keys().forEach((key, index) => {
if (key === './index.js') return;
Object.assign(apiObj, requireApi(key));
})


export {apiObj}



// WEBPACK FOOTER //
// ./src/conf/api/index.js